import * as React from 'react';
import styled from 'styled-components';
import { CloseButton } from '../CloseButton';
import { IFilterTagProps } from './FilterTag.types';

const StyledFilterTag = styled.div`
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 18px;
  margin-left: 8px;
  display: inline-flex;
  flex-direction: row;
  padding: 4px 8px;
  background: ${({ theme }) => theme.colors.background2};
  color: ${({ theme }) => theme.colors.font1};
  border-radius: 4px;
  align-items: center;
  cursor: pointer;
`;

const FilterTag: React.FC<IFilterTagProps> = (props: IFilterTagProps) => {
  const { filterKey, value, onRemoveTag, testId } = props;

  return (
    <StyledFilterTag
      className="filter-tag"
      data-testid={testId || 'filter-tag'}
    >
      {value}
      <CloseButton
        type="button"
        onClick={() => {
          if (onRemoveTag) {
            onRemoveTag(filterKey);
          }
        }}
      >
        <i />
      </CloseButton>
    </StyledFilterTag>
  );
};

export default FilterTag;
